export const IMAGE_HEIGHT_WIDTH_RATIO_HERO = '56.2763713';
export const IMAGE_HEIGHT_WIDTH_RATIO_INFO_BLOCK = '71.355932203';
export const IMAGE_HEIGHT_WIDTH_RATIO_COMPOSITION_IMAGE = '56.25';
